import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'

export const BillboardAtom = styled(GatsbyImage)<{ fit?: boolean }>`
  position: absolute;
  inset: 0;
  object-fit: ${(p) => (p.fit ? 'contain' : 'cover')};
  border-radius: inherit;
  &.hidden {
    opacity: 0;
  }
`

export const BgImg = styled.img<{ fit?: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  object-fit: ${(p) => (p.fit ? 'contain' : 'cover')};
  &.hidden {
    opacity: 0;
    position: absolute;
    z-index: -1;
    pointer-events: none;
  }
`
